import React, { useEffect, useRef, useState } from 'react';
import { Col, Row } from 'antd';
import PropTypes from 'prop-types';
import ColorPicker from 'components/ColorPicker';
import CropIconMapping from 'components/CropIconMapping';

const WRAP_THRESHOLD = 21;

const CropColorRow = ({ crop, cropColor, onColorChange }) => {
  const [isWrapped, setIsWrapped] = useState(false);
  const textRef = useRef(null);

  useEffect(() => {
    if (textRef.current) {
      setIsWrapped(textRef.current.scrollHeight > WRAP_THRESHOLD);
    }
  }, [crop.name]);

  return (
    <Row
      className={`h-auto ${isWrapped ? 'items-start' : 'items-center'}`}
      align={isWrapped ? 'top' : 'middle'}
    >
      <Col className="mr-2px flex-shrink-0">
        <CropIconMapping cropObject={crop} />
      </Col>
      <Col
        className="whitespace-normal break-words w-1/2 flex-grow text-gray-800"
        ref={textRef}
      >
        {crop.name}
      </Col>

      <Col flex="auto" />

      <Col className="items-start flex-shrink-0">
        <ColorPicker
          cropId={crop.id}
          value={cropColor}
          onChange={onColorChange}
        />
      </Col>
    </Row>
  );
};

CropColorRow.propTypes = {
  crop: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    name: PropTypes.string.isRequired
  }).isRequired,
  cropColor: PropTypes.string.isRequired,
  onColorChange: PropTypes.func.isRequired
};

export default CropColorRow;
